const { fetcher } = require('services/helpers/responseHandler')

const categorizeRateCode = async ({ rateCode, rateKind }) =>
  fetcher.post('billing/rateCode', { rateCode, rateKind })

const emailReconciledInvoices = async ({ invoiceId }) =>
  fetcher.post('billing/reconcile/notifyEvaluated', { invoiceId })

const roi = async () => fetcher.get('billing/invoices/roi')

const roiEmails = async () => fetcher.get('billing/invoices/roi/emails')

const sendInvoice = async model => fetcher.post('billing/invoice/send', model)

const invoicedBookings = async ({ invoiceId }) =>
  fetcher.get(`billing/conversions/consumed`, { invoiceId })

const billingContacts = async () => fetcher.get('users/forbilling?isForGroup=false')

const makeBillingPaymentDefault = async ({ paymentAccountId }) =>
  fetcher.put('billing/payment/account/default', { defaultAccountId: paymentAccountId })

const getSavedPaymentMethods = async () => fetcher.get('billing/payment/accounts')

const deletePaymentMethod = async ({ paymentAccountId }) =>
  fetcher.del(`billing/payment/account/delete/${paymentAccountId}`)

const updatePaymentMethod = async ({
  cvv,
  expirationYear,
  expirationMonth,
  paymentAccountId
}) =>
  fetcher.put('billing/payment/account/update', {
    SubsidiaryBillingSavedPaymentAccountId: paymentAccountId,
    creditCard: {
      expirationMonth,
      expirationYear,
      cvv
    }
  })

const billingApi = {
  categorizeRateCode,
  emailReconciledInvoices,
  roi,
  roiEmails,
  sendInvoice,
  invoicedBookings,
  billingContacts,
  makeBillingPaymentDefault,
  getSavedPaymentMethods,
  deletePaymentMethod,
  updatePaymentMethod
}

export default billingApi
